var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"slide"},[_c('p',{staticClass:"gl-mb-7"},[_vm._v("\n    "+_vm._s(_vm.__(
        "We've improved the GitLab user experience with a more modern, intuitive interface built on a new panel-based layout.",
      ))+"\n  ")]),_vm._v(" "),_c('illustration')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }